import styled from "styled-components";

export const SUpgradeProjectWarningModal = styled.div`
  padding: 32px;
  width: 448px;
`;
